export const arrBufferToString = (arrBuffer = []) => {
  const decoder = new TextDecoder("utf-8");
  return decoder.decode(arrBuffer);
};

export const stringToArrBuffer = (string = '') => {
  const encoder = new TextEncoder();
  return encoder.encode(string).buffer;
};
